var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('highchart',{ref:"highchart",staticClass:"highchart",attrs:{"options":_vm.chartOptions,"constructorType":'stockChart'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }